<template>
    <LayoutDashboard title="Unidades de Medida">
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarUnidadeMedida" outlined v-if="$helper.verificaPermissao('cadastrar-unidade-medida')">Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getUnidadesMedidas" :search="search" dense>
                    <template v-slot:item.permite_fracionamento="{ item }">
                        <v-icon :color="item.permite_fracionamento ? 'green' : 'red'" > {{ item.permite_fracionamento ? 'check' : 'close' }} </v-icon>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarUnidadeMedida(item)" v-if="$helper.verificaPermissao('visualizar-unidade-medida')">Visualizar</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalCadastroUnidadeMedida />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroUnidadeMedida from "./ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroUnidadeMedida
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Nome', align: 'left', sortable: false, value: 'unidade'},
                    { text: 'Permite fracionamento', value: 'permite_fracionamento'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([ 
                'getUnidadesMedidas'
            ])
        },
        methods: {
            ...mapActions([
                'listarUnidadeMedida',
                'visualizarUnidadeMedida',
                'cadastrarUnidadeMedida',
                'setModalCadastroUnidadeMedida'
            ])
        },
        created() {
            this.listarUnidadeMedida()
        }
    }
</script>